export enum StakingVersion {
  v1,
  v2,
  difference,
}
